define([
	"./_TextAlignVertical",
	"./PluginFactory"
], function(_TextVerticalAlign,PluginFactory) {

	return PluginFactory.declare(_TextVerticalAlign, {
		"class": "csi-button-toggle csi-toggle-group-first",
		cssValue: "flex-start",
		materialIcon: "vertical_align_top",
		pluginName: "verticalTop",
		title: "CanvasAlignTextVerticalTop"
	});
});
